<template>
  <a class="product-entry" @click="gotoProduct(product)" v-bind:class="{highlighted: highlighted}">
    <img :src="product.image" :alt="product.title"/>
    <div class="product-details">
        <div class="title-wrapper"><div class="product-title ellipsis maxlines-2">{{product.title}}</div></div>
        <div class="product-subtitle ellipsis maxlines-2">{{product.subtitle}}</div>
        <p class="product-description"><span v-html="product.description"></span> &nbsp;</p>
        <!--<a class="morelink textlink">{{labels.more}}</a>-->
    </div>
  </a>
</template>

<script>

import DataLayer from '../services/datalayer.js';
import State from '../services/state.js';
import Labels from "../services/labels.js";

export default {
  name: "ProductUI",
  props: {
    product : {
        type: Object
    },
    highlighted: {
        type: Boolean
    }
  },
  data (){
      return {
          labels: Labels
      }
  },
  methods: {
      gotoProduct(product) {
          DataLayer.recordProduct(product, State.filterValues);
          window.open(`${product.url}?utm_term=Ecolabels`, "ecolabel");
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .product-entry {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    padding: 20px 0;
    border-bottom: 1px dashed #eeeeee;
  }
  .product-entry:first-of-type {
      padding-top: 0;
  }

  .product-entry > img {
      width: 96px;
      min-width: 96px;
      height: 96px;
      border-top-left-radius:10px;
        border-bottom-left-radius:10px;
        border-top-right-radius:0px;
        border-bottom-right-radius:0px;
  }

  .product-entry > .product-details {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      width:100%;
  }

  .product-entry > .product-details > .title-wrapper {
      display: flex;
      align-items: center;
  }

  .product-entry > .product-details > .title-wrapper > .product-title {
      font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
      font-weight: 700;
      font-size: 18px;
      color: black;
  }
  .product-entry > .product-details > .product-subtitle {
      font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
      font-weight: 500;
      font-size: 16px;
      color: black;
      text-transform: uppercase
  }

  .product-entry > .product-details > .product-description {
      font-family: "Gotham Narrow", Arial, Helvetica, sans-serif;
      font-weight: 100;
      font-size: 15px;
      color: black;
  }

  .product-entry > .product-details > p {
      margin-bottom: 0px;
  }

  .product-entry > .product-details > .morelink {
      display: block;
      line-height: 15px;
      margin-top:5px;
      font-weight: 700;
  }

  .product-entry > .product-details > .title-wrapper > .bookmark {
      display: none;
  }

  @media all and (max-width:600px) {
      .product-entry {
            text-decoration: none;
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
            cursor: pointer;
            padding: 10px;
        }

        .product-entry > img {
            width: 48px;
            min-width: 48px;
            height: 48px;
            border-top-left-radius:6px;
            border-bottom-left-radius:6px;
            border-top-right-radius:0px;
            border-bottom-right-radius:0px;
        }
  }

</style>

